<template>
  <span 
    v-if="rubric === null"
    class="tag mb-1 mt-1"
    :style="{ 'background-color': '#' + color }"
    :class="{ 'private-tag': groupTag }"
  >
    <span
        @click="toggleTagOptionModal()"
        class="text">{{ title }}
    </span>
    <TagOptionsModal
      @close="showTagOptionModal = false"
      v-if="showTagOptionModal"
      :id="id"
      :color="color"
      :groupTag="groupTag"
      :rubric='rubric'
      :title='title'
      :owner='owner'
      :commentID="commentID"
    />
    <button v-if="editing" @click="removeTag(id)" class="delete"></button>
  </span>

  <span v-else class="tags has-addons mb-1 mt-1" :style="{ 'background-color': '#' + color }">

      <span class="tag is-rubric">
        <RubricIcon />
      </span>
      <a @click="toggleRubricItemModal()" class="tag" :style="{ 'background-color': '#' + color }">{{ title }}</a>
      <RubricItemModal
        v-if="rubric !== null && showRubricItemModal"
        @close="showRubricItemModal = false"
        :title="title"
        :ascending="rubric.ascending"
        :headerA="rubric.header1"
        :headerB="rubric.header2"
        :headerC="rubric.header3"
        :headerD="rubric.header4"
        :headerE="rubric.header5"
        :descA="rubric.desc1"
        :descB="rubric.desc2"
        :descC="rubric.desc3"
        :descD="rubric.desc4"
        :descE="rubric.desc5"
        :valA="rubric.val1"
        :valB="rubric.val2"
        :valC="rubric.val3"
        :valD="rubric.val4"
        :valE="rubric.val5"
        :score="score"
        :scoreID="scoreID"
        :commentID="commentID"
        :tagID="id"
        :videoID="videoID"
        :rubricID="rubric.id"
        :color="color"
        :owner='owner'
      />

    <button v-if="editing" @click="removeTag(id)" class="delete is-rubric"></button>
  </span>
</template>

<script>
import store from '../store.js'
import RubricIcon from './RubricIcon.vue'
import RubricItemModal from './RubricItemModal.vue'
import TagOptionsModal from './TagOptionsModal.vue'

import {
  removeTagFromComment,
} from '../actionTypes'

export default {
  name: 'Tag',
  components: {
    RubricIcon,
    RubricItemModal,
    TagOptionsModal,
  },
  data () {
    return {
      showRubricItemModal: false,
      showTagOptionModal: false,
    }
  },
  props: {
    id: {
      required: true,
    },
    color: {
      required: true,
    },
    title: {
      required: true,
    },
    editing: {
      type: Boolean,
      required: false,
    },
    commentID: {
      type: Number,
      required: false,
    },
    videoID: {
      type: Number,
      required: false,
    },
    rubric: {
      required: false,
    },
    score: {
      type: Number,
      required: false,
    },
    scoreID: {
      type: Number,
      required: false,
    },
    groupTag: {
      required: true,
    },
    owner: {
      required: true,
    },
  },
  methods: {
    async removeTag (tagID) {
      const { videoID, commentID } = this
      await store.dispatch(removeTagFromComment, { videoID, tagID, commentID })
    },
    toggleRubricItemModal () {
      this.showRubricItemModal = !this.showRubricItemModal
    },
    toggleTagOptionModal () {
      this.showTagOptionModal = !this.showTagOptionModal
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../_variables.scss';

span.tag {
  height: auto;
}

.private-tag {
  border-left: 10px solid orange;
}

.tag {
  background-color: rgb(229, 0, 233);
  border-radius: 3px;
  overflow-x: hidden;
  min-height: 2rem;
  max-width: 400px;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: .25rem;
  }

  .text {
    color: whitesmoke;
    font-weight: bold;
    overflow-x: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

span.tag.is-rubric {
  background-color: #474787;
  color: whitesmoke;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.has-addons {
  
  border-radius: 3px;

  .tag {
    margin: 0px;

    &:not(:first-child) {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      margin-right: 2px;
    }
    &:not(:last-child) {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Tag.vue?73a1d0a4